<template>
  <div v-if="!loading" id="user-view">
    <v-row>
      <v-col cols="12" md="5" lg="4">
        <bread-crumbs
          :context="{
            houseName: getCurrentHouseName,
            houseId: roomData.house,
            roomName: roomData.name,
          }"
        />
        <room-bio-panel :loading="loading" :house-choices="houseChoices" />
      </v-col>

      <v-col cols="12" md="7" lg="8">
        <v-tabs v-model="roomTab" show-arrows class="user-tabs">
          <v-tab>
            <span v-t="'occupants'" />
          </v-tab>
          <v-tab v-if="$can(ACTIONS.READ, PRIVATE.STAFF.OCCUPANCY_HISTORY)">
            <span v-t="'accommodationHistory'" />
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="roomTab" class="mt-3" touchless>
          <v-tab-item>
            <room-occupants-table v-if="roomData.id || !loading" @refetch-data="fetchRoomData" />
          </v-tab-item>
          <v-tab-item v-if="$can(ACTIONS.READ, PRIVATE.STAFF.OCCUPANCY_HISTORY)">
            <room-occupancy-history-table v-if="roomData.id" />
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mdiChevronLeft } from '@mdi/js'
import { onMounted, onUnmounted, ref, computed, watch } from '@vue/composition-api'
import { useActions, useMutations, useState } from 'vuex-composition-helpers'
import { useRouter } from '@core/utils'
import router from '@/router'
// eslint-disable-next-line object-curly-newline
import RoomBioPanel from './room-bio-panel/RoomBioPanel.vue'
import RoomOccupantsTable from './room-occupants/RoomOccupantsTable.vue'
import RoomOccupancyHistoryTable from './room-occupancy-history/RoomOccupancyHistoryTable.vue'
import BreadCrumbs from '@/components/files-table/BreadCrumbs.vue'
import { ACTIONS, PRIVATE } from '@/plugins/acl/const'

export default {
  components: {
    BreadCrumbs,
    RoomBioPanel,
    RoomOccupantsTable,
    RoomOccupancyHistoryTable,
  },
  setup() {
    const houseChoices = ref([])
    const loading = ref(false)
    const roomTab = ref(0)

    const { getRoomDetails, getHouseChoices } = useActions('staff', ['getRoomDetails', 'getHouseChoices'])
    const { roomData } = useState('staff', ['roomData'])
    const { SET_POSITION_DATA } = useMutations('staff', ['SET_POSITION_DATA'])

    const fetchRoomData = async () => {
      const roomId = router.currentRoute.params.id
      if (!roomId || roomId === 'null' || roomId === 'undefined') {
        router.push({ name: 'logistics-apartments-list' })

        return
      }

      loading.value = true
      const { success } = await getRoomDetails(roomId)
      loading.value = false
      if (!success) {
        router.push({ name: 'logistics-apartments-list' })
      }
    }

    const { route } = useRouter()

    watch(
      () => route.value.params.id,
      async () => {
        await fetchRoomData()
      },
    )

    const getCurrentHouseName = computed(() => {
      return houseChoices.value.find((house) => house.value === roomData.value.house)?.text
    })

    onMounted(async () => {
      await fetchRoomData()
      houseChoices.value = await getHouseChoices()
    })

    onUnmounted(() => {
      SET_POSITION_DATA({})
    })

    return {
      fetchRoomData,

      getCurrentHouseName,

      roomData,
      houseChoices,
      loading,
      roomTab,
      ACTIONS,
      PRIVATE,
      icons: {
        mdiChevronLeft,
      },
    }
  },
}
</script>

<style lang="scss">
@import '@core/preset/preset/apps/user.scss';
</style>
